export const SKINS = {
  standard: 'standard',
  inverted: 'inverted',
  destructive: 'destructive',
  premium: 'premium',
  dark: 'dark',
  light: 'light',
  transparent: 'transparent',
  premiumLight: 'premium-light',
  ai: 'ai',
} as const;

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const PRIORITY = {
  primary: 'primary',
  secondary: 'secondary',
} as const;
